import { GET_ACCOMPLISHMENT,ADD_ACCOMPLISHMENT,TOST_MESSAGE, UPDATE_ACCOMPLISHMENT, DELETE_ACCOMPLISHMENT } from '../actions/actionTypes';

const initialState = {
  accomplishmentscardItemData:[],accomplishmentstotalCount:0,accomplishmentscardData:[],cardItemDataShow:false,opentost:false,tost_msg:''
};

function checkdate (data)  {
  let enddate =false;
let date1 =   JSON.parse(data).issueDate;

  console.log('date1',date1);

  return date1;
}


export default function accomplishments(state = initialState, action) {

  switch (action.type) {
     case GET_ACCOMPLISHMENT:
      
      return{
       ...state,
       accomplishmentscardData: action.getCardData,
       accomplishmentstotalCount:action.totalCount,
       accomplishmentscardItemData:action.cardItemData,
       cardItemDataShow:action.cardItemDataShow
      

      };
      case ADD_ACCOMPLISHMENT:
        if(!action.newlyAddedAccomplishment) {
          //accomplishment addition failed for some reason, just return back previous state
          return {
            ...state
          }
        }
        console.log("Action in add accomplishment reducer",action)

        let updatedAccomplishments = state.accomplishmentscardItemData
        if(!action.uploadedImage) {
          updatedAccomplishments.push(action.newlyAddedAccomplishment)
        } else {
          updatedAccomplishments.push({ ...action.newlyAddedAccomplishment, uploadedImage: action.uploadedImage })
        }


        let totalCount=0;
        let finaldata=[];
        let setCardItemDataShow=false;

        totalCount = updatedAccomplishments.length

        let getCardItemData = updatedAccomplishments.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));

        if(totalCount > 3) {
          setCardItemDataShow = true
        }

        if(getCardItemData.length > 0) {
          for (let i = 0; i < getCardItemData.length; i++) {
            const data = getCardItemData[i].newdata;
            let img =   getCardItemData[i].uploadedImage;
            if(img !="" && img!=undefined)
            {
                getCardItemData[i]['profile_image']=img;
            }
            let datecheck = checkdate(data);
  
            getCardItemData[i]['datecheck'] = datecheck;
  
            //restricted i.e. if education is publically viewable logic goes here. Add that logic if needed
  
            ///handling logic
          }
        } 


        let getCardItemData2 = getCardItemData.sort((a, b) => Date.parse(b.datecheck) - Date.parse(a.datecheck))

        finaldata = getCardItemData2


      
        return{
          ...state,
          opentost:action.opentost,
          tost_msg:action.tost_msg,
          accomplishmentscardItemData: finaldata.length > 3 ? finaldata.slice(0,3) : finaldata,
          accomplishmentstotalCount: totalCount,
          cardItemDataShow: setCardItemDataShow,
          accomplishmentscardData: action.getCardData
        };
      case UPDATE_ACCOMPLISHMENT:
        console.log("Action in update accomplishment reducer", action)
        if(!action.updatedAccomplishmentItem) {
          console.log("Accomplishment update failed")
          // accomplishment was not updated, just return back the previous state
          return {
            ...state
          }
        }
      
        const matchingAccItemIndex = state.accomplishmentscardItemData.findIndex(accItem => accItem.id === action.updatedAccomplishmentItem.id)
        console.log("matchingAccItemIndex in acc update reducaer", matchingAccItemIndex)
        let matchingAccItem = undefined;
        if(matchingAccItemIndex !== -1) {
          //if there is file uploaded then add it as well
          if(action.uploadedImage) {
           matchingAccItem = state.accomplishmentscardItemData[matchingAccItemIndex]
           console.log("Matching Item", matchingAccItem)
           matchingAccItem['profile_image'] = action.uploadedImage
           matchingAccItem['newdata'] = action.updatedAccomplishmentItem.newdata
            console.log("matchingAccItem after update", matchingAccItem)
            if(matchingAccItem) {
              state.accomplishmentscardItemData[matchingAccItemIndex] = matchingAccItem
            }
          } else {
            state.accomplishmentscardItemData[matchingAccItemIndex] = action.updatedAccomplishmentItem
          }
        }

        console.log("Acc Items state after update", state.accomplishmentscardItemData)

        return {
          ...state
        }

      case DELETE_ACCOMPLISHMENT:
        if(action.deleteSuccess) {
          const accomplishmentsAfterDelete = action.accomplishmentcardItemData

          let totalCountAfterDelete
          let finaldataAfterDelete=[];
          let setCardItemDataShowAfterDelete=false;

          totalCountAfterDelete = accomplishmentsAfterDelete.length

          let cardItemsData = accomplishmentsAfterDelete.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));

          if(totalCountAfterDelete > 3) {
            setCardItemDataShowAfterDelete = true
          }

          if(cardItemsData.length > 0){
            for(let i=0;i< cardItemsData.length;i++) {
              const data = cardItemsData[i].newdata;
              let img = cardItemsData[i].uploadedImage
              {
                cardItemsData[i]['profile_image']=img;
              }
              let datecheck = checkdate(data);
              cardItemsData[i]['datecheck'] = datecheck;
            }
          }

          let cardItemsData2 = cardItemsData.sort((a, b) => Date.parse(b.datecheck) - Date.parse(a.datecheck))

          finaldataAfterDelete = cardItemsData2

          return {
            ...state,
            accomplishmentscardItemData: finaldataAfterDelete,
            accomplishmentstotalCount: totalCountAfterDelete,
            cardItemDataShow: setCardItemDataShowAfterDelete
          }
        } else {
          //delete was not successful
          return {
            ...state
          }
        }
        
      case TOST_MESSAGE:
        return{
          ...state,
          openTost:action.openTost,
          Tost_msg:action.Tost_msg,
          Msg_type:action.Msg_type,
        };
    default: return state;
  }
};